/**
 * Role / identity helpers for CMS screens.
 *
 * Several lists are scoped per internal user (Lead Inbox, Demo Bookings, …):
 * a normal admin sees only what is assigned to them, a super-admin sees
 * everything. Keeping that rule in one place so the screens can't drift apart.
 */

// The role string is stored at login as user.role — casing/format varies by
// environment, so normalize before comparing.
export const currentRole = () =>
  (localStorage.getItem("trade_user_type") || "").toLowerCase().trim();

export const isSuperAdmin = () => {
  const role = currentRole();
  return role === "super-admin" || role === "super_admin" || role === "superadmin";
};

/** Logged-in internal user id (number), or "" when not available. */
export const currentUserId = () =>
  Number(localStorage.getItem("trade_user_id")) || "";
